module.exports = __webpack_public_path__ + "img/li.9e40c74.svg";